
export type UnlikeTweet200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
